import { AlertCircle, Wrench } from 'lucide-react';
import { FINDING_PROBLEMS, FINDING_SUGGESTED_FIX, FINDING_LABELS } from '../../utils/findingLabels';

export default function IssueLine({ finding }) {
  const problem = FINDING_PROBLEMS[finding] || FINDING_LABELS[finding] || finding;
  const fix = FINDING_SUGGESTED_FIX[finding];

  return (
    <div className="py-2 first:pt-0 last:pb-0 border-b last:border-b-0 border-[var(--color-warm-100)]">
      <div className="flex items-start gap-2">
        <AlertCircle className="w-4 h-4 text-[var(--color-danger-600)] shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <p className="text-[13px] text-[var(--color-warm-900)]">
            <span className="font-semibold">Issue:</span> {problem}
          </p>
          {fix && (
            <p className="text-[12px] text-[var(--color-warm-600)] mt-0.5 flex items-start gap-1.5">
              <Wrench className="w-3 h-3 text-[var(--color-warm-500)] shrink-0 mt-0.5" />
              <span><span className="font-medium">Suggested:</span> {fix}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
